<template>
  <div>
    <SiruiSearch
      ref="baseInfoFormRef"
      :query="query"
      :columns="formColumn"
      :isQueryPanel="false"
      :isDisabledForm="true"
    ></SiruiSearch>
  </div>
</template>

<script>
  import mixin from './../mixin';
  import { yesNoList } from '@/constants/yesNoList';

  export default {
    name: 'message',
    mixins: [mixin],
    props: {
      query: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      formColumn() {
        return [
          {
            name: '公司',
            prop: 'workOrderCompanyName',
            type: 'input',
            disabled: true,
          },
          {
            name: '工单名称',
            prop: 'name',
            type: 'input',
          },
          {
            name: '派单部门',
            prop: 'workOrderDepartmentNo',
            type: 'select',
            options: this.departmentList || [],
            currentValue: this.query.workOrderDepartmentNo,
          },
          {
            name: '是否关联报修单',
            prop: 'relatedRepairFlag',
            type: 'select',
            options: yesNoList || [],
          },
          {
            name: '报修单号',
            prop: 'repairNo',
            type: 'input',
          },
          {
            name: '接单人',
            prop: 'receivePersonName',
            type: 'input',
          },

          {
            name: '联系电话',
            prop: 'contactPhone',
            type: 'input',
          },
          {
            name: '计划完工日期',
            prop: 'planCompleteDate',
            type: 'date',
          },
          {
            name: '实施方式',
            prop: 'executeMode',
            type: 'select',
            options: this.setOptions.executeMode || [],
          },
          {
            name: '派单人',
            prop: 'dispatchPersonName',
            type: 'input',
          },
          {
            name: '派单时间',
            prop: 'dispatchTime',
            type: 'input',
          },
          {
            name: '备注',
            prop: 'remark',
            type: 'textarea',
            maxlength: 50,
          },
        ];
      },
    },
  };
</script>

<style></style>
